import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppDataService, ProductService } from 'app/services';
import { MessageService } from 'primeng/api';
import { ProductItems } from '../../../../../models/product/get-product-request';

@Component({
  selector: 'view-product-dialog',
  templateUrl: './view-product-dialog.component.html',
  styleUrls: ['./view-product-dialog.component.scss','../../../../../../styles/default-material-theme.scss'],
  providers: [MessageService],
})
export class ViewProductDialogComponent implements OnInit {
  productItem: ProductItems | null = null;
  loading = false;

  constructor(
    private appData: AppDataService,
    private messageService: MessageService,
    private productService: ProductService,
    private dialogRef: MatDialogRef<ViewProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { productItem: ProductItems }
  ) {}

  ngOnInit(): void {
    if (this.data?.productItem) {
      this.productItem = this.data.productItem;
    }
  }

  // TODO: get this from the product data
  get productTags(): string[] {
    // ProductItems doesn't have Tags property, so return placeholder tags
    // In a real implementation, you'd get this from a separate service call
    return [];
  }


  onEdit(): void {
    // Close dialog and emit edit action
    this.dialogRef.close({ action: 'edit', product: this.productItem });
  }

  onRemove(): void {
    // Close dialog and emit remove action
    this.dialogRef.close({ action: 'remove', productId: this.productItem?.Id });
  }
}
